import { Component } from '@angular/core';

@Component({
  selector: 'ui-loader-dialog',
  templateUrl: './loader-dialog.component.html',
  styleUrls: ['./loader-dialog.component.scss'],
})
export class LoaderDialogComponent {}
